interface ConsentContent {
	iconName: string
	iconAltText: string
	text: string
}

export const parseConsent = (
	consentText: string,
): readonly ConsentContent[] | null => {
	const consentLines = consentText.split('\n').map((l) => l.trim())
	const lines = consentLines.map((l) =>
		l.match(/\* !\[([^\]]+)\]\(([a-z]+)\) (.*)/),
	)
	if (lines.some((l) => l === null)) {
		return null
	}

	return lines.map((l) => {
		const [_, iconAltText, iconName, text] = l!
		return {
			iconName: iconName!,
			iconAltText: iconAltText!,
			text: text!,
		}
	})
}
